/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrderMemo200Response
 */
export interface GetOrderMemo200Response {
    /**
     * 注文メモのID
     * @type {string}
     * @memberof GetOrderMemo200Response
     */
    uuid: string;
    /**
     * 注文番号
     * @type {string}
     * @memberof GetOrderMemo200Response
     */
    orderNo: string;
    /**
     * 会社コード
     * @type {string}
     * @memberof GetOrderMemo200Response
     */
    companyCode: string;
    /**
     * メモ本文
     * @type {string}
     * @memberof GetOrderMemo200Response
     */
    text: string;
    /**
     * 楽観ロック制御用のバージョン番号
     * @type {number}
     * @memberof GetOrderMemo200Response
     */
    version: number;
    /**
     * 作成日時（UTC）
     * @type {Date}
     * @memberof GetOrderMemo200Response
     */
    createdAt: Date;
    /**
     * 更新日時（UTC）
     * @type {Date}
     * @memberof GetOrderMemo200Response
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the GetOrderMemo200Response interface.
 */
export function instanceOfGetOrderMemo200Response(value: object): value is GetOrderMemo200Response {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('orderNo' in value) || value['orderNo'] === undefined) return false;
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetOrderMemo200ResponseFromJSON(json: any): GetOrderMemo200Response {
    return GetOrderMemo200ResponseFromJSONTyped(json, false);
}

export function GetOrderMemo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderMemo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'orderNo': json['order_no'],
        'companyCode': json['company_code'],
        'text': json['text'],
        'version': json['version'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function GetOrderMemo200ResponseToJSON(json: any): GetOrderMemo200Response {
    return GetOrderMemo200ResponseToJSONTyped(json, false);
}

export function GetOrderMemo200ResponseToJSONTyped(value?: GetOrderMemo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'order_no': value['orderNo'],
        'company_code': value['companyCode'],
        'text': value['text'],
        'version': value['version'],
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': ((value['updatedAt']).toISOString()),
    };
}

